import * as Yup from "yup";

export const shareClassScheme = Yup.object().shape({
  name: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  productList: Yup.string().required("Product is required"),
  type: Yup.string().required("Shareclass Type is required"),
  typeDescription: Yup.string().required("Type Description is required"),
  years: Yup.number()
    .typeError("Year must be a number")
    .required("Years is required"),
  yearsDescription: Yup.string().required("Year Description is required"),
  catId: Yup.string().required("Please select a Product"),
  crmShareClassGuid: Yup.string().required(
    "Please Enter the CRM ShareClass GUID"
  ),
  secondaryDescription: Yup.string().required(
    "Secondary Description is required"
  ),
  language: Yup.string().required("Language is required"),
});
